import Typography from "@mui/material/Typography";
import { OutlinedPaper } from "../../../components/OutlinedPaper";
import { abbreviateNumber } from "../../../utils/numberUtils";
import { Skeleton } from "../../../components/loading";

export const CompanyCountCard = (props: {
  companyCount: number;
  loading: boolean;
}) => {
  const { companyCount, loading } = props;

  return (
    <OutlinedPaper
      id="company-count-card"
      sx={{
        p: 2,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Typography variant="h4">Number of Companies</Typography>
      <Skeleton isLoading={loading} height={30} width={50} margin="3px 0 0 0">
        <Typography
          variant="h2"
          data-testid="catalog-product-company-count-value"
        >
          {companyCount < 999 ? companyCount : abbreviateNumber(companyCount)}
        </Typography>
      </Skeleton>
    </OutlinedPaper>
  );
};
